<template>
    <div>
        <v-dialog v-model="dialogVisible" max-width="900px" persistent>
            <v-card>
                <v-card-title class="primary white--text">
                    <v-icon left color="white">mdi-file-document</v-icon>
                    Náhľad investorskej dohody
                    <v-spacer></v-spacer>
                    <v-btn icon color="white" @click="closeDialog">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text class="pa-6">
                    <!-- Upozornenie o stave zmluvy -->
                    <v-alert type="warning" outlined class="mb-4">
                        <v-row align="center">
                            <v-col>
                                <strong>DÁTUM PLATNOSTI A ÚČINNOSTI TEJTO DOHODY:</strong>
                                <span v-if="!contractEffectiveDate" class="red--text ml-2">
                                    Dohoda zatiaľ nie je platná, lebo investovaná suma zatiaľ nebola pripísaná na náš
                                    účet.
                                </span>
                                <span v-else class="green--text ml-2">
                                    {{ formatDate(contractEffectiveDate) }}
                                </span>
                            </v-col>
                        </v-row>
                    </v-alert>

                    <!-- Obsah zmluvy -->
                    <div class="contract-content" id="contract-content">
                        <!-- Hlavička -->
                        <div class="text-center mb-6">
                            <h2 class="text-h4 primary--text mb-2">INVESTORSKÁ DOHODA</h2>
                        </div>

                        <!-- I. Strany Dohody -->
                        <v-card outlined class="mb-4">
                            <v-card-subtitle class="primary--text font-weight-bold">
                                I. Strany Dohody
                            </v-card-subtitle>
                            <v-card-text>
                                <v-row>
                                    <v-col cols="12" md="6">
                                        <h4 class="mb-2">Spoločnosť:</h4>
                                        <v-list dense>
                                            <v-list-item>
                                                <v-list-item-content>
                                                    <v-list-item-title>Názov spoločnosti:</v-list-item-title>
                                                    <v-list-item-subtitle class="text-body-1">
                                                        VB GUARD s.r.o.
                                                    </v-list-item-subtitle>
                                                </v-list-item-content>
                                            </v-list-item>
                                            <v-list-item>
                                                <v-list-item-content>
                                                    <v-list-item-title>IČO:</v-list-item-title>
                                                    <v-list-item-subtitle class="text-body-1">
                                                        51 851 491
                                                    </v-list-item-subtitle>
                                                </v-list-item-content>
                                            </v-list-item>
                                            <v-list-item>
                                                <v-list-item-content>
                                                    <v-list-item-title>Adresa sídla:</v-list-item-title>
                                                    <v-list-item-subtitle class="text-body-1">
                                                        Páričkova 5, 821 08 Bratislava
                                                    </v-list-item-subtitle>
                                                </v-list-item-content>
                                            </v-list-item>
                                            <v-list-item>
                                                <v-list-item-content>
                                                    <v-list-item-title>Zodpovedná osoba:</v-list-item-title>
                                                    <v-list-item-subtitle class="text-body-1">
                                                        konateľ, Boris Wagner
                                                    </v-list-item-subtitle>
                                                </v-list-item-content>
                                            </v-list-item>
                                            <v-list-item>
                                                <v-list-item-content>
                                                    <v-list-item-title>IBAN:</v-list-item-title>
                                                    <v-list-item-subtitle class="text-body-1 font-weight-bold">
                                                        SK98 8330 0000 0091 1199 1119
                                                    </v-list-item-subtitle>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <h4 class="mb-2">Investor/Investorka:</h4>
                                        <v-list dense>
                                            <v-list-item>
                                                <v-list-item-content>
                                                    <v-list-item-title>Meno a Priezvisko:</v-list-item-title>
                                                    <v-list-item-subtitle class="text-body-1">
                                                        {{ userInfo.first_name }} {{ userInfo.last_name }}
                                                    </v-list-item-subtitle>
                                                </v-list-item-content>
                                            </v-list-item>
                                            <v-list-item>
                                                <v-list-item-content>
                                                    <v-list-item-title>Adresa trvalého bydliska:</v-list-item-title>
                                                    <v-list-item-subtitle class="text-body-1">
                                                        {{ userInfo.address || 'Adresa nebola zadaná' }}
                                                    </v-list-item-subtitle>
                                                </v-list-item-content>
                                            </v-list-item>
                                            <v-list-item v-if="userInfo.birth_number">
                                                <v-list-item-content>
                                                    <v-list-item-title>Rodné číslo:</v-list-item-title>
                                                    <v-list-item-subtitle class="text-body-1">
                                                        {{ userInfo.birth_number }}
                                                    </v-list-item-subtitle>
                                                </v-list-item-content>
                                            </v-list-item>
                                            <v-list-item v-if="userInfo.iban">
                                                <v-list-item-content>
                                                    <v-list-item-title>IBAN:</v-list-item-title>
                                                    <v-list-item-subtitle class="text-body-1">
                                                        {{ userInfo.iban }}
                                                    </v-list-item-subtitle>
                                                </v-list-item-content>
                                            </v-list-item>
                                            <v-list-item>
                                                <v-list-item-content>
                                                    <v-list-item-title>Číslo ID na platforme FICHEE
                                                        MEDIA:</v-list-item-title>
                                                    <v-list-item-subtitle class="text-body-1 font-weight-bold">
                                                        {{ userInfo.id }}
                                                    </v-list-item-subtitle>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list>
                                    </v-col>
                                </v-row>

                                <!-- Investičné údaje -->
                                <v-divider class="my-4"></v-divider>
                                <v-row>
                                    <v-col cols="12" md="4">
                                        <div class="text-center">
                                            <div class="text-caption">Číslo investície - ID investície</div>
                                            <div class="text-h6 primary--text">{{ investmentId }}</div>
                                        </div>
                                    </v-col>
                                    <v-col cols="12" md="4">
                                        <div class="text-center">
                                            <div class="text-caption">Dátum návrhu investície</div>
                                            <div class="text-h6">{{ formatDate(proposalDate) }}</div>
                                        </div>
                                    </v-col>
                                    <v-col cols="12" md="4">
                                        <div class="text-center">
                                            <div class="text-caption">Výška investície</div>
                                            <div class="text-h5 success--text font-weight-bold">
                                                {{ formatCurrency(investmentAmount) }}
                                            </div>
                                        </div>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>

                        <!-- II. Preambula -->
                        <v-card outlined class="mb-4">
                            <v-card-subtitle class="primary--text font-weight-bold">
                                II. Preambula
                            </v-card-subtitle>
                            <v-card-text>
                                <div class="text-body-1 line-height-1-6">
                                    <p>1. Táto Dohoda sa uzatvára za účelom kapitalizácie 10 projektov Fichee.
                                        Celková výška štartovacieho kapitálu v súvislosti s touto dohodou je 10 000 000
                                        €.
                                    </p>

                                    <p>2. Týchto 10 Projektov <strong>FICHEE</strong> je bližšie špecifikovaných na
                                        stránke
                                        FICHEE MEDIA v sekcií <strong>CHCEM VÝBORNE INVESTOVAŤ</strong>.</p>

                                    <p>3. Všetkých 10 Projektov <strong>FICHEE</strong> je viazaných na Spoločnosť VB
                                        GUARD
                                        s.r.o.
                                        a na jej číslo účtu <strong>IBAN: SK98 8330 0000 0091 1199 1119</strong>, kde sa
                                        bude
                                        sústrediť celý štartovací kapitál pre všetkých 10 Projektov
                                        <strong>FICHEE</strong>.
                                        Ak by sa zmenila Spoločnosť vlastniaca toto číslo účtu, tak len za podmienky, že
                                        nová
                                        spoločnosť a jej nové číslo účtu prevezme všetky záväzky plynúce z tejto Dohody
                                        na
                                        túto
                                        novú spoločnosť a jej nové číslo účtu.</p>
                                </div>

                                <v-alert type="info" outlined class="mt-4">
                                    <div class="font-weight-bold mb-2">Táto Dohoda platí len ak:</div>
                                    <ol class="ml-4">
                                        <li>boli finančné prostriedky plynúce z konkrétnej investície pripísané na číslo
                                            účtu Spoločnosti
                                            <strong>IBAN: SK98 8330 0000 0091 1199 1119</strong>
                                        </li>
                                        <li>a zároveň takúto Dohodu vygeneroval systém na stránke FICHEE MEDIA na adrese
                                            <a href="http://www.fmedia.top" target="_blank">www.fmedia.top</a> a takáto
                                            dohoda sa
                                            nachádza v sekcií konkrétneho investora. V prípade technických problémov a z
                                            toho
                                            plynúcich dôvodov, ak by sa nezobrazovala táto konkrétna Dohoda na stránke
                                            <a href="http://www.fmedia.top" target="_blank">www.fmedia.top</a> tak platí
                                            len
                                            podmienka č.1 a síce, že investované prostriedky boli pripísané na účet
                                            Spoločnosti
                                            <strong>IBAN: SK98 8330 0000 0091 1199 1119</strong>
                                        </li>
                                        <li>dojednania, ktoré nie sú špecifikované v tejto Dohode sa riadia platnými
                                            zákonmi
                                            v Slovenskej republike v čase uzavretia tejto Dohody.</li>
                                    </ol>
                                </v-alert>
                            </v-card-text>
                        </v-card>

                        <!-- III. Investícia Drobného investora -->
                        <v-card outlined class="mb-4">
                            <v-card-subtitle class="primary--text font-weight-bold">
                                III. Investícia Drobného investora
                            </v-card-subtitle>
                            <v-card-text>
                                <div class="text-body-1 line-height-1-6">
                                    <p>1. Výška investície Drobného investora je v rozmedzí 10 € až 10 000 € a môže to
                                        byť
                                        len násobok čísla 10.</p>

                                    <p>2. Drobný investor môže investovať podľa bodu III.1. a III.3. tejto Dohody aj
                                        opakovane,
                                        viac krát, pričom suma jeho investície sa mu bude kumulatívne spočítavať.</p>

                                    <p>3. Termín možnosti investície Drobného investora je limitovaný celkovo
                                        naakumulovanou
                                        sumou
                                        štartovacieho kapitálu vo výške 10 000 000 €. 10 projektov Fichee si vyhradzuje
                                        právo
                                        kedykoľvek zastaviť možnosť prijímania ďalších investícií od Drobných investorov
                                        a
                                        to aj
                                        pred naakumulovaním požadovaného štartovacieho kapitálu.</p>

                                    <p>4. Suma menej ako 10 € sa bude považovať ako dar a nevzťahuje sa na ňu táto
                                        Verejná
                                        Dohoda.</p>

                                    <p>5. Suma viac ako 10 000 € môže byť vrátená Drobnému investorovi v plnej výške ale
                                        po
                                        odpočítaní nákladov spojených so spätným prevodom ako sú napríklad poplatky a
                                        kurzové rozdiely.</p>

                                    <p>6. Ak chce investor investovať viac ako 10 000 € môže tak urobiť na základe
                                        konzultácie
                                        na emailovej adrese <a
                                            href="mailto:investiciafichee@gmail.com">investiciafichee@gmail.com</a></p>
                                </div>
                            </v-card-text>
                        </v-card>

                        <!-- IV. Záväzok platby -->
                        <v-card outlined class="mb-4" color="success lighten-5">
                            <v-card-subtitle class="success--text font-weight-bold">
                                IV. Záväzok platby z 10 projektov Fichee pre Drobného investora
                            </v-card-subtitle>
                            <v-card-text>
                                <div class="text-body-1 line-height-1-6">
                                    <p>1. Každý druhý mesiac sa zaväzuje spoločnosť, ktorá bude prevádzkovať projekt
                                        Fichee
                                        zaplatiť každému Drobnému investorovi podľa bodu IV.2. tejto Dohody sumu
                                        rovnajúcu
                                        sa
                                        výške jeho vkladu do projektu Fichee a to prevodom na účet drobného investora,
                                        ktorý
                                        má nastavený vo svojom profile.</p>

                                    <p>2. Výška vkladu drobného investora je naakumulovaná suma súčtu všetkých
                                        investičných
                                        vkladov každého individuálneho Drobného investora samostatne, ktoré do projektu
                                        Fichee
                                        vložil až do doby uzavretia možnosti vkladať Drobnými investormi investičné
                                        vklady
                                        do
                                        projektu Fichee.</p>

                                    <p>3. Podmienkou vyplácania sumy Drobnému investorovi vyplývajúcej z bodu IV.1. je,
                                        že
                                        projekt Fichee dosiahne v danom mesiaci obrat 300 000 000 €.</p>
                                </div>
                            </v-card-text>
                        </v-card>

                        <!-- V. Ostatné dojednania -->
                        <v-card outlined class="mb-4">
                            <v-card-subtitle class="primary--text font-weight-bold">
                                V. Ostatné dojednania
                            </v-card-subtitle>
                            <v-card-text>
                                <div class="text-body-1 line-height-1-6">
                                    <p>1. Ak ktokoľvek iný a akokoľvek inak pristúpi k projektu Fichee, bude musieť
                                        automaticky
                                        na základe tejto Dohody, ktorá je neoddeliteľnou súčasťou projektu Fichee plniť
                                        všetky
                                        dojednania plynúce z tejto Dohody.</p>

                                    <p>2. Investícia do projektu Fichee nie je dediteľná ani inak prevoditeľná na inú
                                        osobu
                                        ako bola osoba Drobného investora, ktorá investovala do projektu na jeho
                                        začiatku.
                                    </p>

                                    <p>3. V prípade prevodu spoločnosti na iného/iných majiteľov bude podmienkou, že
                                        táto
                                        Verejná Dohoda ostane v platnosti aj naďalej.</p>

                                    <p>4. Platnosť zmluvy nadobúda účinnosť na strane projektu Fichee dňom 01.01.2020 a
                                        na
                                        strane Drobného investora dňom pripísania jeho investície na účet projektu
                                        Fichee
                                        uvedeného v Preambule.</p>

                                    <p>5. Táto Verejná Dohoda sa uzatvára na dobu neurčitú bez možnosti výpovede.</p>

                                    <p>6. Túto Verejnú Dohodu nie je možné meniť.</p>
                                </div>

                                <v-alert type="info" outlined class="mt-4">
                                    Investícia nie je príjem Spoločnosti ale len vklad do spoločnosti. Vrátenie vkladu
                                    Spoločnosti sa neúčtuje ako náklad spoločnosti ale vyplatenie benefitu sa účtuje ako
                                    náklad spoločnosti.
                                </v-alert>
                            </v-card-text>
                        </v-card>

                        <!-- Platobné údaje -->
                        <v-card outlined class="mb-4" color="success lighten-5">
                            <v-card-subtitle class="success--text font-weight-bold">
                                <v-icon left small color="success">mdi-bank-transfer</v-icon>
                                Platobné údaje
                            </v-card-subtitle>
                            <v-card-text>
                                <v-row>
                                    <v-col cols="12" sm="6">
                                        <div class="text-caption">Príjemca</div>
                                        <div class="text-body-1 font-weight-medium">VB GUARD s.r.o.</div>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <div class="text-caption">IBAN</div>
                                        <div class="text-body-1 font-weight-bold primary--text">SK98 8330 0000 0091 1199
                                            1119</div>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <div class="text-caption">Suma na úhradu</div>
                                        <div class="text-h6 success--text font-weight-bold">{{
                                            formatCurrency(investmentAmount) }}</div>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <div class="text-caption">Variabilný symbol (vaše ID)</div>
                                        <div class="text-h6 warning--text font-weight-bold">{{ userInfo.id }}</div>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <div class="text-caption">Poznámka / správa pre príjemcu</div>
                                        <div class="text-body-1">investicia fichee</div>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>

                        <!-- Podpis -->
                        <div class="text-center mt-6">
                            <p><strong>V Bratislave na stránke <a href="http://www.fmedia.top"
                                        target="_blank">www.fmedia.top</a></strong></p>
                            <p><strong>Dátum: {{ formatDate(proposalDate) }}</strong></p>
                        </div>
                    </div>
                </v-card-text>

                <v-card-actions class="pa-6">
                    <v-btn color="grey" outlined @click="closeDialog">
                        <v-icon left>mdi-close</v-icon>
                        Zavrieť
                    </v-btn>

                    <!-- <v-btn color="info" outlined @click="downloadContractPDF" :loading="pdfLoading">
                    <v-icon left>mdi-download</v-icon>
                    Stiahnuť PDF
                </v-btn> -->

                    <v-spacer></v-spacer>

                    <v-btn color="success" large @click="confirmInvestment" :loading="loading">
                        <v-icon left>mdi-check</v-icon>
                        Súhlasím a chcem investovať
                    </v-btn>
                </v-card-actions>
            </v-card>

            <!-- Confirmation Dialog -->
            <v-dialog v-model="confirmationDialog" max-width="500px" persistent>
                <v-card>
                    <v-card-title class="warning white--text">
                        <v-icon left color="white">mdi-alert</v-icon>
                        Potvrdenie investície
                    </v-card-title>
                    <v-card-text class="pa-4">
                        <div class="text-body-1 mb-4">
                            Ste si istý, že chcete investovať sumu <strong>{{ formatCurrency(investmentAmount)
                                }}</strong>?
                        </div>

                        <v-alert type="info" outlined>
                            Po potvrdení bude vytvorená dohoda a budete presmerovaný na platbu.
                            Investícia sa stane aktívnou až po pripísaní sumy na náš účet.
                        </v-alert>

                        <div class="mt-4">
                            <v-checkbox v-model="agreementChecked"
                                :rules="[v => !!v || 'Musíte súhlasiť s podmienkami']">
                                <template v-slot:label>
                                    <div>
                                        Súhlasím s podmienkami investorskej dohody a potvrdzujem, že som si prečítal
                                        všetky dôležité informácie o investícii.
                                    </div>
                                </template>
                            </v-checkbox>
                        </div>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn color="grey" @click="confirmationDialog = false">
                            Zrušiť
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn color="success" :disabled="!agreementChecked" @click="finalConfirmInvestment"
                            :loading="loading">
                            Definitívne potvrdiť
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-dialog>

        <!-- Payment Details Dialog -->
        <payment-details-dialog v-model="paymentDetailsDialog" :amount="investmentAmount"
            :variable-symbol="userInfo && userInfo.id ? userInfo.id : null" />
    </div>
</template>

<script>
import PaymentDetailsDialog from '@/components/invest/PaymentDetailsDialog.vue';

export default {
    name: "ContractPreviewDialog",

    components: {
        PaymentDetailsDialog
    },

    props: {
        value: {
            type: Boolean,
            default: false
        },
        investmentAmount: {
            type: Number,
            default: 0
        },
        userInfo: {
            type: Object,
            default: () => ({
                id: 1,
                first_name: '',
                last_name: '',
                email: '',
                address: '',
                birth_number: '',
                iban: ''
            })
        },
        contractEffectiveDate: {
            type: [String, Date],
            default: null
        }
    },

    data() {
        return {
            loading: false,
            pdfLoading: false,
            confirmationDialog: false,
            agreementChecked: false,
            proposalDate: new Date(),
            paymentDetailsDialog: false,
            // investmentId: null
        };
    },

    computed: {
        investmentId() {
            return `${this.userInfo.id}/X`;
        },

        dialogVisible: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        }
    },

    mounted() {
        // Generate investment ID when component mounts
        // this.generateInvestmentId();
    },

    methods: {
        closeDialog() {
            this.dialogVisible = false;
            this.confirmationDialog = false;
            this.agreementChecked = false;
        },

        confirmInvestment() {
            this.confirmationDialog = true;
        },

        finalConfirmInvestment() {
            if (!this.agreementChecked) return;

            this.loading = true;

            const investmentData = {
                investment_id: this.investmentId,
                investment_amount: this.investmentAmount,
                proposal_date: this.proposalDate,
                user_info: this.userInfo,
                bank_account: {
                    iban: 'SK98 8330 0000 0091 1199 1119',
                    recipient: 'VB GUARD s.r.o.'
                }
            };

            this.$emit('confirm', investmentData);

            // Reset state
            setTimeout(() => {
                this.loading = false;
                this.confirmationDialog = false;
                this.agreementChecked = false;
                this.closeDialog();
                this.paymentDetailsDialog = true;
            }, 1000);
        },

        formatCurrency(amount) {
            if (amount == null || amount === '') return '0€';
            const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount;
            if (isNaN(numAmount)) return '0€';

            return new Intl.NumberFormat('sk-SK', {
                style: 'currency',
                currency: 'EUR'
            }).format(numAmount);
        },

        formatDate(date) {
            if (!date) return '';
            const d = new Date(date);
            return d.toLocaleDateString('sk-SK', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            });
        },

        copyToClipboard(text) {
            if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(text).then(() => {
                    // Show success message
                    this.$emit('copied', text);
                }).catch(() => {
                    console.error('Failed to copy');
                });
            } else {
                // Fallback for older browsers
                const textArea = document.createElement('textarea');
                textArea.value = text;
                document.body.appendChild(textArea);
                textArea.focus();
                textArea.select();
                try {
                    document.execCommand('copy');
                    this.$emit('copied', text);
                } catch (err) {
                    console.error('Failed to copy');
                }
                document.body.removeChild(textArea);
            }
        }
    }
};
</script>

<style scoped>
.contract-content {
    font-family: 'Times New Roman', serif;
    line-height: 1.6;
    background: white;
    padding: 20px;
}

.line-height-1-6 {
    line-height: 1.6;
}

.contract-content h2 {
    margin-bottom: 1rem;
}

.contract-content p {
    margin-bottom: 0.8rem;
    text-align: justify;
}

.contract-content ol,
.contract-content ul {
    margin-bottom: 1rem;
}

.contract-content li {
    margin-bottom: 0.4rem;
}

.v-card>>>.v-card__subtitle {
    padding-bottom: 8px;
}

/* Print styles */
@media print {
    .v-dialog {
        position: static !important;
    }

    .v-card-actions {
        display: none !important;
    }

    .v-alert {
        border: 1px solid #ccc !important;
    }

    .contract-content {
        font-size: 11pt;
    }
}

/* Mobile responsive */
@media (max-width: 600px) {
    .contract-content {
        font-size: 0.9rem;
        padding: 10px;
    }

    .text-h4 {
        font-size: 1.5rem !important;
    }

    .text-h5 {
        font-size: 1.3rem !important;
    }

    .text-h6 {
        font-size: 1.1rem !important;
    }
}

/* PDF Generation Styles */
#contract-content {
    background: white;
    color: black;
}

#contract-content .v-card {
    border: 1px solid #ddd !important;
    box-shadow: none !important;
}

#contract-content .v-alert {
    border: 1px solid #1976d2 !important;
    background: #e3f2fd !important;
}
